import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function postalCodeValidator(pais: string, paisListado?: any): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        let paisListadoCode: string;
        const value = { 'postalCode': { value: control.value }};
        if(paisListado && typeof paisListado === 'object' && paisListado.hasOwnProperty('CountryCode')){
            paisListadoCode = paisListado.CountryCode;
        }
        if(pais === 'pt' && control.value && control.value !== '' && (paisListadoCode && paisListadoCode !== 'PT' && paisListadoCode !== 'ES')){
            return null;
        }else if (pais === 'pt' && control.value && control.value !== '') {
            return control.value.match(/^\d{4}-\d{3}$|^\d{5}$/g) ? null : value;
        } else {
            return null;
        }
    };

}
